import { render, staticRenderFns } from "./users-table.vue?vue&type=template&id=d67ee5e0&"
import script from "./users-table.vue?vue&type=script&lang=ts&"
export * from "./users-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d67ee5e0')) {
      api.createRecord('d67ee5e0', component.options)
    } else {
      api.reload('d67ee5e0', component.options)
    }
    module.hot.accept("./users-table.vue?vue&type=template&id=d67ee5e0&", function () {
      api.rerender('d67ee5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/users/components/users-table.vue"
export default component.exports